const appointmentAdapter = (data: any) => {
  const proccess = {
    serviceType: data.tipoDeServicio.split(" ")[0],
    confirmationForm: data.titulosFormularios,
  };
  return proccess;
};
export default appointmentAdapter;
